import { render, staticRenderFns } from "./RemoteClean.vue?vue&type=template&id=ba7cc9ec"
import script from "./RemoteClean.vue?vue&type=script&lang=js"
export * from "./RemoteClean.vue?vue&type=script&lang=js"
import style0 from "./RemoteClean.vue?vue&type=style&index=0&id=ba7cc9ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports